import { countryList } from 'constants/countryList';
import { getLanguage } from './language';
import { getMessage } from '../i18n/i18nWrapper';

/**
 * Get Country name from it's corresponding country code
 * @param {String} countryCode
 * @return {Object} country name and id
 */
export function getCountryFromCode(countryCode) {
  const list = countryList();
  const country = list.filter((currCountry) => {
    return currCountry.id === countryCode;
  })[0];
  if (country) {
    return { country: country.value, countryId: country.id };
  }
  return { country: getMessage('country.US'), countryId: 'US' };
}

/**
 * Get user's location based on user's language
 * @return {Object} country name and id
 */
export function getUserCountryByLanguage() {
  const language = getLanguage();
  if (language) {
    const [, langCountryCode] = language.split('-');
    if (langCountryCode) {
      return getCountryFromCode(langCountryCode);
    }
  }
  return { country: getMessage('country.US'), countryId: 'US' };
}

/**
 * Create Google Geocodings API link for determining user's location by coordinates
 * @param {Object} coordinates Object containing latitude and longitude of user
 * @return {String} Google API URL
 */
export function createGoogleMapURL(coordinates) {
  let GOOGLE_KEY;
  // eslint-disable-next-line no-process-env
  if (process.env.NODE_ENV === 'production') {
    GOOGLE_KEY = 'AIzaSyBaUWqAMBo4jbBicevvZhFdf9dIYHQFUDY';
  } else {
    GOOGLE_KEY = 'AIzaSyCwxs-PN5pEB4UeKVHUoLNsB0ufQ_ByyvY';
  }
  const GOOGLE_BASE_URL = 'https://maps.googleapis.com/maps/api/geocode/json';
  const { latitude, longitude } = coordinates;

  const finalURL = `${GOOGLE_BASE_URL}?latlng=${latitude},${longitude}&key=${GOOGLE_KEY}`;
  return finalURL;
}
